var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.438 2.54h4.498l-9.827 11.23 11.56 15.284h-9.051l-7.09-9.27-8.112 9.27h-4.5l10.51-12.013L1.336 2.539h9.281l6.409 8.473zM22.859 26.36h2.492L9.263 5.09H6.59z"
  })));
};
export default SvgTwitterIcon;